<template>
  <section class="manage-users-page">
    <header class="manage-users-page__header">
      <h1 class="manage-users-page__page-title">
        Manage Users &#38; Permissions
      </h1>
    </header>
    <section>
      <UsersTable
        ref="usersTable"
        :auth-user="authUser"
        @refresh-reports="handleRefreshReports()"
      />
      <ReportsTable
        ref="reportsTable"
        :auth-user="authUser"
        @refresh-users="handleRefreshUsers()"
      />
    </section>
    <WelcomeModal :auth-user="authUser" />
  </section>
</template>

<script>
  import WelcomeModal from '~/components/dashboard/manage-users-and-permissions/WelcomeModal.vue';
  import UsersTable from '~/components/dashboard/manage-users-and-permissions/UsersTable.vue';
  import ReportsTable from '~/components/dashboard/manage-users-and-permissions/ReportsTable.vue';

  export default {
    components: {
      WelcomeModal,
      UsersTable,
      ReportsTable,
    },
    props: {
      authUser: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      mfaEnabled: false,
    }),
    methods: {
      handleRefreshReports() {
        this.$refs.reportsTable.getReports();
        this.$refs.reportsTable.getUserList();
      },
      handleRefreshUsers() {
        this.$refs.usersTable.getUsers();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .manage-users-page {
    z-index: 0;
    padding: 55px;
    min-height: calc(100vh - 237px);

    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 2rem;
      z-index: 0;
      border-top: none;
    }
    &__page-title {
      margin: 0;
      margin-right: 1rem;
      font-size: 35px;
    }
    &__switch-label {
      margin: 0;
      margin-right: 1rem;
      font-size: 16px;
      font-style: italic;
      font-weight: 400;
      color: #585b60;
    }
  }
</style>
